var path = '/app/components/dialogs/select-monkey/select-monkey.html';
var html = "<div class=custom-modal-wrap> <div class=custom-modal> <div class=modal-title> <div class={{$ctrl.resolve.label}}></div> </div> <div class=modal-body id=modal-body> <div class=container-fluid> </div> </div> <a class=\"btn-select ok-alert\" ng-click=$ctrl.submit(1) ng-class=\"\" style=bottom:5rem;left:-35rem></a> <a class=\"btn-select ok-alert\" ng-click=$ctrl.submit(2) ng-class=\"\" style=bottom:5rem;left:40rem></a> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/select-monkey/select-monkey.html
// module id = 227
// module chunks = 0